<!--
 * @Description: 线上系统展示
 * @Author: youme
 * @LastEditors: youme
 * @Date: 2023-05-04 15:11:18
 * @LastEditTime: 2024-02-02 13:25:14
-->
<template>
  <div class="system-display-body">
    <div class="group-items">
      <div class="group-item">
        <div class="item-title">HSMOM</div>
        <div>
          <Button type="primary" class="item-button" @click="() => handleOpen('http://39.152.151.71:9003/')">HSMOM</Button>
        </div>
      </div>
      <div class="group-item">
        <div class="item-title">HSMES</div>
        <div>
          <div class="button-item">
            <Button type="primary" class="item-button" @click="() => handleOpen('http://powertrain-mes.ihaosmart.com:7777')">动力总成</Button>
            <Button type="primary" class="item-button" @click="() => handleOpen('http://39.152.151.71:9017')">模组PACK</Button>
          </div>
          <div class="button-item">
            <Button type="primary" class="item-button" @click="() => handleOpen('http://fuzhen-mes.ihaosmart.com:7777')">电机电驱</Button>
            <Button type="primary" class="item-button" @click="() => handleOpen('http://sinomach-demo.ihaosmart.com:7777')">盘柜组装</Button>
          </div>
          <div class="button-item">
            <!-- <Button type="primary" class="item-button" @click="() => handleOpen('http://123.177.45.40:30023')">模组PACK</Button> -->
            <!-- <Button type="primary" class="item-button" @click="() => handleOpen()">分容化成</Button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="group-items" style="margin-top: 80px">
      <div class="group-item">
        <div class="item-title">HSWMS</div>
        <div>
          <Button type="primary" class="item-button" @click="() => handleOpen('http://wcs-manage-demo.ihaosmart.com:7777')">HSWMS</Button>
        </div>
      </div>
      <div class="group-item">
        <div class="item-title">HSQMS</div>
        <div>
          <Button type="primary" class="item-button" @click="() => handleOpen('http://39.152.151.71:9015')">HSQMS</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui'

export default {
  name: 'SystemDisplay',
  components: { Button },
  methods: {
    handleOpen(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.system-display-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-image: url('../assets/systemDisplay/background.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .group-items {
    display: flex;

    .group-item {
      width: 450px;

      .item-title {
        position: relative;
        font-family: ArialMT, sans-serif;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 50px;
        padding-left: 44px;
        line-height: 24px;

        &::before {
          position: absolute;
          content: '';
          height: 22px;
          width: 34px;
          left: 0;
          top: 0;
          background-image: url('../assets/systemDisplay/icon.png');
        }
      }

      .item-button {
        width: 200px;
        height: 60px;
        font-size: 24px;
        font-weight: 400;
      }

      .button-item {

        & + .button-item {
          margin-top: 32px;
        }

        .el-button + .el-button {
          margin-left: 48px;
        }
      }
    }
  }
}
</style>
